// cities.json is a 150k-city dataset, ~21 MB of JSON, and it exists to fill one
// dropdown on the calendar. Imported at the top of this file it landed in the
// main bundle, so every page — the homepage, an article, every crawler render —
// downloaded and parsed all of it. Importing it inside a function makes webpack
// split it into its own chunk, fetched only where it is actually used.
let citiesPromise = null;

const loadCities = () => {
  if (!citiesPromise) {
    citiesPromise = import('cities.json')
      .then((module) => module.default ?? module)
      .catch((error) => {
        // Don't cache the failure: the next visit to the calendar can try again.
        citiesPromise = null;
        throw error;
      });
  }

  return citiesPromise;
};

/** Cities of the countries ECDS has a member organization in, keyed by country name. */
export const getCities = async (organizations) => {
  const cities = await loadCities();

  const groupedCitiesByCountries = cities.reduce((acc, { country, name }) => {
    if (!acc[country]) {
      acc[country] = [];
    }

    acc[country].push(name);

    return acc;
  }, {});

  const countryNames = organizations.reduce((acc, { country, countryAcronym }) => {
    acc[countryAcronym] = country;
    return acc;
  }, {});

  return Object.entries(groupedCitiesByCountries).reduce((acc, [acronym, cityNames]) => {
    const countryName = countryNames[acronym];
    if (countryName) {
      acc[countryName] = cityNames;
    }
    return acc;
  }, {});
};

/** Every city of the above as one sorted list — takes what getCities returned. */
export const getCityOptions = (citiesByCountry) =>
  [...new Set(Object.values(citiesByCountry).flat())].sort();
